






















































import {
  GetFilteredAuditsByCriteriaPayload,
  AuditAvailabilityForCriteriaUpdate,
} from '@/store/modules/projects/types/projects.types';
import { AuditDetail } from '@/store/modules/audits/types/audits.types';
import { RootState } from '@/store/store';
import { ApiState, Pagination } from '@/store/types/general.types';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import BasePagination from '@/components/base/BasePagination.vue';

@Component({
  components: {
    BasePagination,
  },
})
export default class UnavailableCyclesDialogue extends Vue {
  @Prop()
  public modalTitle!: string;
  @Prop()
  public confirmButtonText!: string;
  @Prop()
  public projectId!: number;
  @Prop()
  public criterionId!: number;

  @Action('projects/getUnavailableFilteredAudits')
  public getUnavailableFilteredAudits!: (
    payload: GetFilteredAuditsByCriteriaPayload,
  ) => void;

  @State((state: RootState) => state.projects.unavailableAudits)
  public unavailableAudits!: Pagination<AuditDetail>;

  @State(
    (state: RootState) => state.projects.apiState.getUnavailableFilteredAudits,
  )
  public unavailableAuditsApiState!: ApiState;

  public storedAudits: AuditDetail[] = [];

  public perPage: number = 10;
  public page: number = 1;

  public closeModal() {
    this.$emit('close');
  }

  public mounted() {
    this.fetchData();
  }

  public getAuditStatus(audit: AuditDetail): string {
    if (audit.endedAt !== null) {
      return 'ended';
    } else if (audit.startedAt !== null) {
      return 'commenced';
    } else if (audit.status === 'Archived') {
      return 'archived';
    }
    return 'not started';
  }

  @Watch('page')
  onPageChange() {
    this.fetchData();
  }

  public fetchData() {
    const params: GetFilteredAuditsByCriteriaPayload = {
      projectId: this.projectId,
      criterionId: this.criterionId,
      filter: AuditAvailabilityForCriteriaUpdate.UNAVAILABLE,
      limit: this.perPage,
      page: this.page,
    };
    this.getUnavailableFilteredAudits(params);
  }

  @Watch('unavailableAuditsApiState', { immediate: true })
  @isTruthy
  public onFilteredAuditsByCriteriaChange(state: ApiState) {
    if (state.success) {
      this.storedAudits = this.unavailableAudits.items;
    }
  }

  get totalNumberOfPage(): number {
    return Math.ceil(this.getTotalCount / this.perPage);
  }

  get startItemIndex(): number {
    return this.page * this.perPage - this.perPage + 1;
  }

  get endItemIndex(): number {
    return Math.min(this.getTotalCount, this.page * this.perPage);
  }

  get isFirstPage(): boolean {
    return this.page === 1;
  }

  get isLastPage(): boolean {
    return this.page === this.totalNumberOfPage;
  }

  get getCurrentPage(): number {
    return this.page;
  }

  get getCurrentPerPage(): number {
    return this.perPage;
  }

  get getTotalCount(): number {
    if (!this.unavailableAudits) {
      return 0;
    }
    return this.unavailableAudits.totalItems != null
      ? this.unavailableAudits.totalItems
      : 0;
  }
}
